const historyLocationActions = require('actions/framework/HistoryLocationActions');
const shouldServiceRun = require('utils/Services').shouldServiceRun;

module.exports = (function () {
    // Stop service from loading if not necessary
    if (!shouldServiceRun.search()) {
        return;
    }

    const InflatorComps = require('utils/framework/InflateComponents');
    const Events = require('utils/framework/Events');
    const store = require('store/Store');
    const UtilActions = require('utils/redux/Actions');
    const { setSearchData } = require('actions/SearchActions');

    Events.onLastLoadEvent(window, [Events.SearchInfoLoaded], function () {
        const searchInfo = InflatorComps.services.SearchInfo.data;

        if (searchInfo) {
            // If 'originalKeyword' is in API response, the user misspelled
            // a keyword. The 'keyword' key is the originalKeyword corrected
            // for spelling. API doc: https://jira.sephora.com/wiki/x/4bEnBw
            if (searchInfo.originalKeyword) {
                store.dispatch(historyLocationActions.replaceLocation({
                    path: location.pathname,
                    queryParams: { 'keyword': encodeURIComponent(searchInfo.keyword) },
                    anchor: location.hash
                }));
            }

            const isJerrySearch = Sephora.renderedData.catOrMouse === 'mouse';

            if (isJerrySearch) {
                store.dispatch(setSearchData(searchInfo));
            } else {
                store.dispatch(UtilActions
                    .merge('catalog', 'catalogData', searchInfo));
            }
            window.dispatchEvent(new CustomEvent(Events.SearchInfoReady, { detail: {} }));
        }
    });
}());
